import { ProductTemplateOption } from '../types';

export const AUTOMATIC_FULFILLMENT_OPTIONS: ProductTemplateOption[] = [
    // Material Inc Transport
    {
        productType: 'BULK_MATERIAL',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT'],
    },
    {
        productType: 'RECYCLED_BULK_MATERIAL',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT'],
    },
    {
        productType: 'NON_HAZARDOUS_WASTE_RECYCLING',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT'],
        formPreset: { disposalPurpose: 'RECYCLING' },
    },
    {
        productType: 'NON_HAZARDOUS_WASTE_DISPOSAL',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT'],
        formPreset: { disposalPurpose: 'DISPOSAL' },
    },
    {
        productType: 'HAZARDOUS_WASTE_RECYCLING',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT'],
        formPreset: { disposalPurpose: 'RECYCLING' },
    },
    {
        productType: 'HAZARDOUS_WASTE_DISPOSAL',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT'],
        formPreset: { disposalPurpose: 'DISPOSAL' },
    },

    // Transport Only
    {
        productType: 'TRANSPORT',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'TON' },
    },
    {
        productType: 'TRANSPORT',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'TRANSPORT' },
    },
];
